import { render, staticRenderFns } from "./shippingFromJapan.vue?vue&type=template&id=87332966&lang=pug"
import script from "./shippingFromJapan.vue?vue&type=script&lang=js"
export * from "./shippingFromJapan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports